export default __webpack_public_path__ + "static/media/tutorial1-4.11e0204f.png";